import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import {useSnackbar} from 'notistack';
import {useAddShippingMethodMutation, useGetShippingMethodsQuery} from 'api';
import ShippingMethodForm from './ShippingMethodForm';

function CreateShippingMethodModal({open, onClose}) {
  const {isLoading, isError} = useGetShippingMethodsQuery();
  const formRef = React.useRef();
  const [addShippingMethod] = useAddShippingMethodMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const {enqueueSnackbar} = useSnackbar();
  return (
    <Dialog fullWidth scroll="body" maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle mb={2} variant="h6">
        Create Shipping Method
      </DialogTitle>
      <DialogContent>
        <ShippingMethodForm
          disabled={isLoading || isError}
          ref={formRef}
          onSubmit={async (values, actions) => {
            try {
              setIsSubmitting(true);
              const newObj = {
                ...values,
              };
              await addShippingMethod(newObj).unwrap();
              actions.resetForm();
              enqueueSnackbar('ShippingMethod created successfully', {
                variant: 'success',
              });
              onClose();
            } catch (e) {
              const message =
                e.status === 400 ? e.ShippingMethodResponse?.details?.[0]?.message : undefined;
              enqueueSnackbar(message || 'Failed to create ShippingMethod', {
                variant: 'error',
              });
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} color="inherit" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          endIcon={isSubmitting ? <CircularProgress ml={2} size={16} /> : null}
          disabled={isSubmitting}
          color="primary"
          variant="contained"
          onClick={() => formRef.current?.submit?.()}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateShippingMethodModal;
